/* eslint-disable no-useless-escape */
import { gql, useMutation } from "@apollo/client";
import React from "react";
import { Helmet } from "react-helmet";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router";
import { FormError } from "../components/form-error";
import { useMe } from "../hooks/useMe";
import { editProfileMutation, editProfileMutationVariables } from "../__generated__/editProfileMutation";

const EDIT_PROFILE_MUTATION = gql`
  mutation editProfileMutation($editProfileInput: EditProfileInput!) {
    editProfile(input: $editProfileInput) {
      ok
      error
    }
  }
`;

interface IEditProfileForm {
  email?: string;
  password?: string;
  confirmPassword?: string;
}
export const EditProfile = () => {
  const { data: meData } = useMe();
  const { register, handleSubmit, getValues, formState, setValue } = useForm<IEditProfileForm>({
    mode: "onChange",
  });

  setValue("email", meData?.me.email);

  const onSubmit = async () => {
    const { email, password } = getValues();
    if (!loading) {
      editProfileMutation({
        variables: {
          editProfileInput: { email, password },
        },
      });
    }
  };
  const history = useHistory();
  const onCompleted = (data: editProfileMutation) => {
    const {
      editProfile: { ok },
    } = data;
    if (ok) {
      history.push(`/profile`);
    }
  };
  const [editProfileMutation, { loading, data: editProfileMutationResult }] = useMutation<
    editProfileMutation,
    editProfileMutationVariables
  >(EDIT_PROFILE_MUTATION, {
    onCompleted,
  });

  return (
    <div className="h-screen bg-black text-white">
      <Helmet>
        <title>Edit Profile | Pocast</title>
      </Helmet>
      <div className="flex flex-col justify-center items-center text-center pt-10">
        <div className="w-full max-w-screen-sm px-5 text-center flex flex-col justify-between ">
          <div className="relative mb-24 mr-auto">
            <div className="text-left text-3xl tracking-wider leading-10 pb-1 text-purple-700">Edit Profile</div>
          </div>
          <form onSubmit={handleSubmit(onSubmit)} className="grid gap-3 mt-5  sm:w-96 sm:mx-auto  mb-5 z-10">
            <div className="text-left flex flex-col">
              <label className="mb-2 pl-2 font-bold text-white">Email</label>
              <input
                {...register("email", {
                  pattern:
                    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                })}
                name="email"
                type="email"
                placeholder="Email"
                autoComplete="off"
                className="rounded-lg p-2 border-2 bg-transparent text-lg bg-gray-900 border-pink-200 transition-colors focus:outline-none focus:border-pink-700 mb-1"
              />
              {formState.errors.email?.type === "pattern" && <FormError errorMessage={"Please enter a valid email"} />}
            </div>
            <div className="text-left flex flex-col">
              <label className="mb-2 pl-2 font-bold text-white">Password</label>
              <input
                {...register("password", { minLength: 8 })}
                name="password"
                type="password"
                placeholder="Password"
                className="rounded-lg focus:outline-none focus:border-pink-700  p-2 border-2 bg-transparent text-lg border-pink-200 transition-colors sm:w-96 sm:mx-auto mb-1 bg-gray-900"
              />
              {formState.errors.password?.type === "minLength" && <FormError errorMessage="Password must be more than 8 chars." />}
            </div>
            <div className="text-left flex flex-col">
              <label className="mb-2 pl-2 font-bold text-white">Confirm Password</label>
              <input
                {...register("confirmPassword")}
                name="confirmPassword"
                type="password"
                placeholder="Confirm Password"
                className="rounded-lg focus:outline-none focus:border-pink-700  p-2 border-2 bg-transparent text-lg border-pink-200 transition-colors sm:w-96 sm:mx-auto mb-1 bg-gray-900"
              />
              {getValues().password !== getValues().confirmPassword && <FormError errorMessage="Password should be same" />}
            </div>
            <button
              className={`flex justify-center py-2 rounded-lg font-bold text-white tracking-wider sm:w-96 sm:mx-auto focus:outline-none bg-pink-700 hover:bg-pink-800 transition delay-75 ${
                loading ? "select-none" : ""
              }`}
            >
              {loading ? "Loading ..." : "Edit Profile"}
            </button>
            {editProfileMutationResult?.editProfile.error && <FormError errorMessage={editProfileMutationResult?.editProfile.error} />}
          </form>
        </div>
      </div>
    </div>
  );
};
